import { RouterProvider } from 'react-router-dom'
import './assets/fonts/fonts.css'
import './index.css'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { useEffect } from 'react'
import { router } from './routes/routes'
import { ThemeProvider } from '@mui/material/styles'
import { theme } from './themes/color-theme'
import packageJson from '../package.json'
function App() {
  useEffect(() => {
    const initFingerprint = async () => {
      const storedFingerprint = localStorage.getItem('fingerprint')
      if (storedFingerprint) {
        return
      } else {
        const fp = await FingerprintJS.load()
        const result = await fp.get()
        const newFingerprint = result.visitorId
        localStorage.setItem('fingerprint', newFingerprint)
      }
    }
    initFingerprint()
  }, [])
  console.log(packageJson.version)

  return (
    <>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </>
  )
}

export default App
